import React from "react";
import { DokuConfigForm } from "../create/create";

const DokuLanding = () => {
  return (
    <div className="space-y-6">
      <DokuConfigForm />
    </div>
  );
};

export default DokuLanding;
